import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 48 48" fill="none">
    {props.children}
    <path fill="#fff" d="M13.3.3 33.8 12v1L13.4 24.6V.3Zm0 26.9 20.5-11.7v30.2l-20.5-12v-6.5Z" />
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M25.5 45.7 18 41.4v-7.8l7.5 4.4v7.7Z"
    />
    <path
      fill="#eea2a2"
      stroke="#eea2a2"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M23 21.6v4.5l-.3-.2v-4l.4-.3Zm-.1 8.9a.8.8 0 0 1-.4-.3l-.1-.5.1-.3h.4l.3.3.1.5v.2l-.2.1h-.3Zm.1-11.4v-3.5l-.3-.2v4l.4-.3Z"
    />
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M13.3.3 33.8 12v1L13.4 24.6V.3Zm0 26.9 20.5-11.7v30.2l-20.5-12v-6.5Z"
    />
    <path
      fill="#eea2a2"
      fillRule="evenodd"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M25.5 7 28 6c2-.7 4.6-.1 7.2 2a22.3 22.3 0 0 1 7.2 19c-.6 3.2-2 5.2-4.2 6l-2.4.8c2-.7 3.6-2.7 4.2-5.9 1-6.3-2.1-14.8-7.2-19-2.6-2.2-5.2-2.8-7.2-2Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.5}
      d="M33 8.9c-2.6-2.1-5.1-2.7-7.1-2-2 .7-3.6 2.7-4.2 5.9-.5 3.1 0 6.8 1.3 10.3a21 21 0 0 0 6 8.8c2.5 2 5 2.7 7 2 2-.7 3.6-2.7 4.2-5.9.5-3.2 0-7-1.3-10.4a20.9 20.9 0 0 0-6-8.7Z"
    />
    <path
      fill="#eea2a2"
      stroke="#eea2a2"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m34.9 29-.7.4 2-1.9.2.2-1.5 1.4Zm-6.3-4-1.5.7 8.4-7.5 1.1-.5-8 7.2Z"
    />
    <path
      fill="#eea2a2"
      stroke="#eea2a2"
      strokeLinejoin="bevel"
      strokeWidth={0.5}
      d="m35.5 15.3-1.2.5 1.2 2.4 1.1-.5-1.1-2.4Zm-6.8-3.6-1.3.5 3.3 6.7 1-1-3-6.2Zm4.3 9.1-1 .8 3.2 6.7 1.2-.7-3.3-6.8Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m27.4 12.2 3.3 6.7 3.6-3.1 1.2 2.4-3.7 3.3 3.3 6.8-1.6 1.4-3.3-6.8-3 2.7-1.2-2.5 3-2.8-3.3-6.7 1.7-1.4Z"
    />
    <path fill="#fff" stroke="#15161a" strokeLinejoin="round" strokeWidth={0.5} d="m16 20-8.6-5V7.1l8.6 5V20Z" />
    <path fill="#eea2a2" stroke="#15161a" strokeLinejoin="bevel" strokeWidth={0.5} d="m16 20 .8-.5v-7.8l-.8.4V20Z" />
    <path fill="#fff" stroke="#15161a" strokeLinejoin="bevel" strokeWidth={0.5} d="m16 12.1.8-.4-8.7-5-.7.4 8.6 5Z" />
    <path fill="#eea2a2" stroke="#000" strokeWidth={0.5} d="m7.8 38.1 2.3 1.3-2.5 1.4-2.2-1.3 2.5-1.4Z" />
    <path fill="none" stroke="#000" strokeWidth={0.5} d="m10.8 39.8 4.8 2.8-2.4 1.4-4.8-2.8 2.5-1.4Zm4.9 4.3 6.2 3.6" />
  </svg>
);
